import { COMPONENTS } from '../../../components/components.registry';
import { ScrollToTopConfig } from '../../../models';

export const DEFAULT_SCROLL_TO_TOP_CONFIG: ScrollToTopConfig = {
  components: {
    scrollToTop: COMPONENTS.PURE.ScrollToTop,
    icon: COMPONENTS.PURE.ChevronUpIcon
  },
  pixelsThreshold: 1000
};
